import { isObject } from 'utils/object/isObject';

export const DISCOVERY_DATA_ENRICHMENT_PATH =
  '/settings/discovery-snapshots/discovery-data-enrichment';

/**
 * Tabs of the Discovery Data Enrichment page are in-page state without their own
 * URL, so the tab to open and the filter to apply are handed over in
 * `location.state`, like the cloud construct explorer does.
 *
 * @see IpfLocation
 */
export const DISCOVERY_DATA_ENRICHMENT_LINK_STATE_KEY =
  'discoveryDataEnrichmentLink';

export type DiscoveryDataEnrichmentLink =
  | { tab: 'rules'; ruleId: string }
  | { tab: 'assignedLabels'; rootId: string };

export type DiscoveryDataEnrichmentLinkState = {
  [DISCOVERY_DATA_ENRICHMENT_LINK_STATE_KEY]?: DiscoveryDataEnrichmentLink;
};

export const readDiscoveryDataEnrichmentLink = (
  locationState: unknown,
): DiscoveryDataEnrichmentLink | null => {
  if (!isObject(locationState)) {
    return null;
  }

  const link = locationState[DISCOVERY_DATA_ENRICHMENT_LINK_STATE_KEY];
  if (!isObject(link)) {
    return null;
  }

  const { tab, ruleId, rootId } = link;

  if (tab === 'rules' && typeof ruleId === 'string') {
    return { tab, ruleId };
  }
  if (tab === 'assignedLabels' && typeof rootId === 'string') {
    return { tab, rootId };
  }

  return null;
};
